// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"print-buttons_wrapper__nlBqO","button":"print-buttons_button__2-BGx","active":"print-buttons_active__36jXb"};